module.exports = __webpack_public_path__ + "static/media/fabric_0004.3b2377d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/fabric_0004.jpg
// module id = 630
// module chunks = 0